import React from 'react';
import BookDemoButton from './BookDemoButton';

const LEAD_FORM = 'https://api.leadconnectorhq.com/widget/form/xSNa1tu0CCXyei8UJ2ew';

const ProductSection = () => (
  <section className="vipo-section vipo-section--bordered">
    <div className="vipo-container vipo-container--narrow">
      <div className="vipo-product__grid">
        {/* RentDirect */}
        <div className="vipo-product__col">
          <div>
            <span className="vipo-product__eyebrow">Rental Platform</span>
            <h2 className="vipo-product__title">See RentDirect in Action</h2>
            <p className="vipo-product__copy">
              One connected platform for bookings, verification, insurance, collections,
              tolls, roadside, and rental workflows.
            </p>
          </div>
          <div className="vipo-product__video">
            <iframe
              src="https://player.vimeo.com/video/1190651320?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              title="RentDirect"
            />
          </div>
        </div>

        {/* RentID */}
        <div className="vipo-product__col">
          <div>
            <span className="vipo-product__eyebrow">Trust &amp; Safety</span>
            <h2 className="vipo-product__title">Meet RentID</h2>
            <p className="vipo-product__copy">
              Verify drivers instantly with ID checks, license status, background checks,
              MVRs, and insurance validation.
            </p>
          </div>
          <div className="vipo-product__video">
            <iframe
              src="https://player.vimeo.com/video/1185610303?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              title="RentID"
            />
          </div>
        </div>
      </div>

      <div className="vipo-cta-row">
        <BookDemoButton />
        <a
          href={LEAD_FORM}
          target="_blank"
          rel="noopener noreferrer"
          className="vipo-btn vipo-btn--secondary"
        >
          Book Demo
        </a>
      </div>
    </div>
  </section>
);

export default ProductSection;
